import React from "react";
import "./Top_Enterprises.css";

function Top_Enterprises() {
  const logos = [
    "/assets/Images/Home/Top_Enterprises/img_1.png",
    "/assets/Images/Home/Top_Enterprises/img_2.png",
    "/assets/Images/Home/Top_Enterprises/img_3.png",
    "/assets/Images/Home/Top_Enterprises/img_1.png",
    "/assets/Images/Home/Top_Enterprises/img_2.png",
    "/assets/Images/Home/Top_Enterprises/img_3.png",
    "/assets/Images/Home/Top_Enterprises/img_1.png",
    "/assets/Images/Home/Top_Enterprises/img_2.png",
    "/assets/Images/Home/Top_Enterprises/img_3.png",
    "/assets/Images/Home/Top_Enterprises/img_1.png",
    "/assets/Images/Home/Top_Enterprises/img_2.png",
    "/assets/Images/Home/Top_Enterprises/img_3.png",
  ];

  return (
    <section className="Top_Enterprises">
      <div className="custom_container">
        {/* Heading */}
        <div className="top_enterprises_heading">
          <h2>Partnered with Over 500 Top Enterprises</h2>
          <p>for Printing, Signage, and Gifting Solutions</p>
        </div>

        {/* Slider */}
        <div className="logo_slider">
          <div className="logo_track">
            {/* Duplicate logos for smooth infinite scroll */}
            {[...logos, ...logos].map((logo, index) => (
              <div className="logo_card" key={index}>
                <img src={logo} alt="logo" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Top_Enterprises;
